import React from "react";
import Preloader from "../../helper/Preloader";
import BottomFooter from "../../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import AccountAmazon from "../../componentsAmazon/AccountAmazon";
import FooterOne from "../../components/FooterOne";
import HeaderFooterInit from "../../componentsAmazon/HeaderFooterInit";
  

const AccountPageAmazon = () => {



  return (
    <>

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderFooterInit */}
      <HeaderFooterInit/>

      {/* Account */}
      <AccountAmazon />
 

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />


    </>
  );
};

export default AccountPageAmazon;
